module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "lxm-contact-item box",
    on: {
      "click": _vm.clicked
    }
  }, [_c('article', {
    staticClass: "media"
  }, [_c('figure', {
    staticClass: "media-left"
  }, [_c('lxm-avatar', {
    attrs: {
      "size": '2.5714rem',
      "src": _vm.avatar,
      "name": _vm.name,
      "isFemale": _vm.isFemale
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [(_vm.name) ? _c('div', {
    staticClass: "lxm-contact-item__name"
  }, [_vm._v("\n        " + _vm._s(_vm.name)), (_vm.org && _vm.org.name) ? _c('span', {
    staticClass: "not-found"
  }, [_vm._v("（" + _vm._s(_vm.org.name) + "）")]) : _vm._e()]) : _c('div', {
    staticClass: "lxm-contact-item__name not-found"
  }, [_vm._v("\n        暂无姓名\n      ")]), _vm._v(" "), (_vm.phone) ? _c('div', {
    staticClass: "lxm-contact-item__phone"
  }, [_vm._v("\n        " + _vm._s(_vm.phone) + "\n      ")]) : _c('div', {
    staticClass: "lxm-contact-item__phone not-found"
  }, [_vm._v("\n        暂无手机号\n      ")])]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-right"
  }, [_c('img', {
    staticClass: "lxm-contact-item__right-arrow",
    attrs: {
      "src": require("../../images/main/contact/item-right-arrow.png")
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-655f123c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-655f123c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/common/LxmContactItem.vue
// module id = 859
// module chunks = 0